
	import { defineComponent, PropType } from 'vue';
	import VueApexCharts from 'vue3-apexcharts';

	import { ChartableCollection } from '@/Models/Charts/ChartableCollection';
	import { IDataTableHeader } from '@/Models/IDataTableHeader';
	import IChartRenderOptions from '@/Models/Charts/IChartRenderOptions';

	import { VisualizerOptions } from '@/Services/Report/visualization-service';

	export default defineComponent({
		name: 'multi-chart',
		components: {
			apexcharts: VueApexCharts,
		},
		props: {
			chartData: {
				type: Object as PropType<ChartableCollection>,
				required: true,
			},
			// complete list of options are here: https://apexcharts.com/docs/options/
			// also, a set of reusable defaults are exported in the visualization service
			chartOptions: {
				type: Object as PropType<IChartRenderOptions>,
				required: false,
				default: VisualizerOptions.getGenericOptions(),
			}
		},
		created() { },
		data() {
			return {
                headers: [
                    { title: "Present in Chart", key: "enable" },
                ] as IDataTableHeader[],
                selectedCharts: [],
            };
		},
		methods: {
            // from https://stackoverflow.com/questions/7225407/convert-camelcasetext-to-title-case-text
            camelCaseToWords(s: string) {
                const result = s.replace(/([A-Z])/g, ' $1');
                return result.charAt(0).toUpperCase() + result.slice(1);
            },
        },
	});
